import { render, staticRenderFns } from "./CourseNew.vue?vue&type=template&id=37d97d2c&scoped=true&"
import script from "./CourseNew.vue?vue&type=script&lang=js&"
export * from "./CourseNew.vue?vue&type=script&lang=js&"
import style0 from "./CourseNew.vue?vue&type=style&index=0&id=37d97d2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d97d2c",
  null
  
)

export default component.exports